import { Modal } from "react-bootstrap";

const steps = [
    {
        num: 1,
        text: 'Drag the email to a board',
    },
    {
        num: 2,
        text: 'Create a task from the email',
    },
    {
        num: 3,
        text: 'Add your reply to the customer',
    },
];

const NoReplyMailModal = ({ showisMailVisible, setShowisMailVisible }) => {
    return (
        <Modal
            show={showisMailVisible}
            onHide={() => setShowisMailVisible(false)}
            size="md"
            centered
            backdrop="static"
        >
            <div style={{
                background: '#fff',
                borderRadius: '16px',
                overflow: 'hidden',
                boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                border: '1px solid #e5e7eb',
            }}>
                {/* Header stripe */}
                <div style={{
                    background: 'linear-gradient(135deg, #f0fdf4 0%, #e8f5e9 100%)',
                    borderBottom: '1px solid #d1fae5',
                    padding: '20px 24px 16px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '10px',
                            background: '#1a7d3e',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                        }}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                <path d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4Z" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M22 6L12 13L2 6" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                        <span style={{ fontWeight: 700, fontSize: '15px', color: '#1a7d3e' }}>
                            How to reply to an email
                        </span>
                    </div>
                    <button
                        onClick={() => setShowisMailVisible(false)}
                        style={{
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            color: '#9ca3af',
                            padding: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            borderRadius: '6px',
                            transition: 'color 0.15s, background 0.15s',
                        }}
                        onMouseEnter={e => { e.currentTarget.style.background = '#f3f4f6'; e.currentTarget.style.color = '#374151'; }}
                        onMouseLeave={e => { e.currentTarget.style.background = 'none'; e.currentTarget.style.color = '#9ca3af'; }}
                    >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                    </button>
                </div>

                {/* Body */}
                <div style={{ padding: '24px' }}>
                    <p style={{ fontSize: '13.5px', color: '#6b7280', marginBottom: '20px', textAlign: 'center', lineHeight: '1.6' }}>
                        Follow these 3 quick steps to manage and respond to incoming emails.
                    </p>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px' }}>
                        {steps.map((step) => (
                            <div key={step.num} style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '14px',
                                background: '#f9fafb',
                                border: '1px solid #e5e7eb',
                                borderRadius: '10px',
                                padding: '12px 16px',
                            }}>
                                <div style={{
                                    width: '28px',
                                    height: '28px',
                                    borderRadius: '50%',
                                    background: '#dcfce7',
                                    border: '1.5px solid #a7f3d0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexShrink: 0,
                                    fontSize: '12px',
                                    fontWeight: '700',
                                    color: '#1a7d3e',
                                }}>
                                    {step.num}
                                </div>
                                <span style={{ fontSize: '13.5px', color: '#374151', fontWeight: '500' }}>
                                    {step.text}
                                </span>
                            </div>
                        ))}
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <button
                            onClick={() => setShowisMailVisible(false)}
                            style={{
                                padding: '10px 36px',
                                fontSize: '14px',
                                fontWeight: '600',
                                color: '#fff',
                                background: '#1a7d3e',
                                border: 'none',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                transition: 'background-color 0.15s ease',
                                boxShadow: '0 2px 8px rgba(26,125,62,0.30)',
                            }}
                            onMouseEnter={e => e.currentTarget.style.background = '#1a6b2e'}
                            onMouseLeave={e => e.currentTarget.style.background = '#1a7d3e'}
                        >
                            Got It
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default NoReplyMailModal;
